<template>
	<div class="loader">
		<p>Loading</p>
		<i class="fa fa-2x fa-spinner fa-spin" aria-hidden="true"></i>
	</div>
</template>

<style scoped>
.loader {
	height: 100%;
	width: 100%;
	position: fixed;
	z-index: 99;
	background-color: #000;
	color: #ca2c92;
	display: flex;
	gap: 10px;
	font-weight: 500;
	font-size: 18px;
	align-items: center;
	justify-content: center;
}
</style>
